export const ImportExportStatus = Object.freeze({
  fail: "fail",
  success: "success",
});
